import React, { useState } from 'react';
import { DatePicker, Dropdown, Button } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';

const Filters = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    catchers,
    catcher,
    setCatcher,
    teams,
    vsTeam,
    setVsTeam,
    lastApps,
    setLastApps,
}) => {
    const { t: translate } = useTranslation();

    const [innerStartDate, setInnerStartDate] = useState(startDate);
    const [innerEndDate, setInnerEndDate] = useState(endDate);
    const [innerCatcher, setInnerCatcher] = useState(catcher);
    const [innerVsTeam, setInnerVsTeam] = useState(vsTeam);
    const [innerLastApps, setInnerLastApps] = useState(lastApps);
    const [showInvalidDateRange, setShowInvalidDateRange] = useState(false);

    const teamOptions = [{ name: translate('common.all'), value: null }, ...teams.map((x) => ({ name: x.FullName, value: x.TeamID }))];
    const catcherOptions = [{ name: translate('common.all'), value: null }, ...catchers.map((x) => ({ name: x.catchername, value: x.catcherid }))];
    const lastAppsOptions = [{ name: translate('common.all'), value: null }, ...([...Array(10).keys()].map((x) => ({ name: x + 1, value: x + 1 })))];

    const onFilter = () => {
        if (innerStartDate > innerEndDate) {
            setShowInvalidDateRange(true);
            return;
        }

        setShowInvalidDateRange(false);
        setStartDate(innerStartDate);
        setEndDate(innerEndDate);
        setCatcher(innerCatcher);
        setVsTeam(innerVsTeam);
        setLastApps(innerLastApps);
    };
    return (
        <div className="d-flex justify-content-end align-items-center">
            <div style={{ width: '120px', flexShrink: 0 }}>
                <DatePicker
                    size="sm"
                    maxDate={new Date()}
                    value={innerStartDate}
                    onSelect={(value) => setInnerStartDate(value)}
                    openToDate={innerStartDate}
                />
            </div>
            <span className="mx-2">{translate('common.to')}</span>
            <div style={{ width: '120px', flexShrink: 0 }}>
                <DatePicker
                    size="sm"
                    maxDate={new Date()}
                    value={innerEndDate}
                    onSelect={(value) => setInnerEndDate(value)}
                    openToDate={innerEndDate}
                />
            </div>
            <div className="d-flex align-items-center ms-2">
                <span>{translate('baseball.catcher_one')}:&nbsp;</span>
                <Dropdown
                    align="end"
                    options={catcherOptions}
                    value={innerCatcher}
                    onSelect={(value) => { setInnerCatcher(value); }}
                />
            </div>
            <div className="d-flex align-items-center mx-2">
                <span>{translate('baseball.abbr-versus')} {translate('baseball.team')}:&nbsp;</span>
                <Dropdown
                    align="end"
                    options={teamOptions}
                    value={innerVsTeam}
                    onSelect={(value) => { setInnerCatcher(catcherOptions[0]); setInnerVsTeam(value); }}
                />
            </div>
            <div className="d-flex align-items-center">
                <span>{translate('sections.opponent.player.num-appearances')}:&nbsp;</span>
                <Dropdown
                    align="end"
                    options={lastAppsOptions}
                    value={innerLastApps}
                    onSelect={(value) => setInnerLastApps(value)}
                />
            </div>
            <Button
                style={{ marginLeft: '8px' }}
                variant="primary"
                onClick={onFilter}
            >
                {translate('common.filter')}
            </Button>
            {showInvalidDateRange
            && (
                <span style={{ color: 'red', marginLeft: '10px' }}>
                    {translate('sections.opponent.player.invalid-combination')}
                </span>
            )}
        </div>
    );
};

export default Filters;
